var _style, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChartSkeleton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1240 386",
    style: {
      enableBackground: "new 0 0 1240 386"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#3C3C3C;stroke-width:0.5;stroke-linecap:square;stroke-opacity:0.16;}\n\t.st2{fill:#F0F0F0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4-13.7h1232c2.2,0,4,2,4,4.4v420c0,2.5-1.8,4.4-4,4.4H4c-2.2,0-4-2-4-4.4v-420C0-11.7,1.8-13.7,4-13.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.2,304.8h1186.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.2,234.1h1186.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.2,162.8h1186.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.2,91.5h1186.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.2,376.8h1186.6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 9.7,
    className: "st2",
    width: 224,
    height: 30
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 58.6,
    className: "st2",
    width: 114,
    height: 15.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209.3,231.1L29,377.5h1195.8V329l-87.7-75.9c-7.8-6.8-18.9-6.8-26.8-0.2l-110.6,93.5 c-7.7,6.5-18.4,6.6-26.2,0.3L742.8,161.3c-7.7-6.2-18.3-6.2-26,0.2l-140,115.2c-7.3,6-17.3,6.4-24.9,1l-39.2-27.6 c-7.3-5.1-16.8-5-24,0.2l-95.5,70.2c-7.1,5.2-16.3,5.4-23.5,0.5l-136-91.1C226.1,224.9,216.4,225.3,209.3,231.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartSkeleton);
export default __webpack_public_path__ + "static/media/LineChartSkeleton.ee127f41ba6ca90f503aa69d441eb270.svg";
export { ForwardRef as ReactComponent };